import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FormContainerDeprecated from './FormContainerDeprecated';
import { emperor } from '../Colors/Colors';
import { large, xxlarge } from '../Styles/spacing';
const LeftContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "FormHeaderDeprecated__LeftContainer",
  componentId: "sc-1q4af4c-0"
})(["text-align:left;flex-basis:0;margin:0.25em 0;", ""], _ref => {
  let {
    hasContent
  } = _ref;
  return hasContent || 'display: none';
});
const TitleContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "FormHeaderDeprecated__TitleContainer",
  componentId: "sc-1q4af4c-1"
})(["text-align:center;font-weight:600;text-overflow:ellipsis;overflow:hidden;max-width:100%;margin:0.5em 0;", ""], _ref2 => {
  let {
    hasContent
  } = _ref2;
  return hasContent || 'display: none';
});
const RightContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "FormHeaderDeprecated__RightContainer",
  componentId: "sc-1q4af4c-2"
})(["text-align:right;flex-basis:0;margin:0.25em 0;", ""], _ref3 => {
  let {
    hasContent
  } = _ref3;
  return hasContent || 'display: none';
});
const Body = /*#__PURE__*/styled(FormContainerDeprecated.Body).withConfig({
  displayName: "FormHeaderDeprecated__Body",
  componentId: "sc-1q4af4c-3"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:", ";color:", ";white-space:nowrap;padding:0 ", ";", ""], xxlarge, emperor, large, _ref4 => {
  let {
    width
  } = _ref4;
  return width > 500 && "\n        flex-direction: row;\n        justify-content: space-between;\n        \n        & ".concat(LeftContainer, " {\n            order: 1;\n            flex-grow: 1;\n            margin: 0;\n            display: block;\n        }\n        & ").concat(TitleContainer, " {\n            order: 2;\n            margin: 0 1em;\n            display: block;\n        }\n        & ").concat(RightContainer, " {\n            order: 3;\n            flex-grow: 1;\n            margin: 0;\n            display: block;\n        }\n    ");
});
/**
 * @deprecated Please use <Form> instead
 */

export default class FormHeaderDeprecated extends React.PureComponent {
  render() {
    console.warn('FormHeader(ui-atoms) IS DEPRECATED. USE Form(ui-forms) INSTEAD.');
    const {
      left,
      children,
      right,
      ...props
    } = this.props;
    return /*#__PURE__*/React.createElement(FormContainerDeprecated, _extends({
      bodyType: Body
    }, props), /*#__PURE__*/React.createElement(TitleContainer, {
      hasContent: !!children
    }, children), /*#__PURE__*/React.createElement(LeftContainer, {
      hasContent: !!left
    }, left), /*#__PURE__*/React.createElement(RightContainer, {
      hasContent: !!right
    }, right));
  }

}

_defineProperty(FormHeaderDeprecated, "propTypes", {
  /**
   * How the container should look. "ghost" would have a white
   * background. "light" has a light grey background. "recessed" has
   * light grey background with shadows on top (if its not the first
   * child) and bottom (if its not the last child)
   */
  context: PropTypes.oneOf(['ghost', 'light', 'recessed']),

  /** Content be aligned to the left on the header */
  left: PropTypes.node,

  /** Content be aligned to the right on the header */
  right: PropTypes.node,

  /** Content be aligned to the middle on the header */
  children: PropTypes.node,

  /** Whether borders should be drawn around the container */
  withBorder: PropTypes.bool
});

_defineProperty(FormHeaderDeprecated, "defaultProps", {
  context: 'light',
  withBorder: true
});